module.exports = __webpack_public_path__ + "img/rich-man-wallet.d84976be.png";